var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(241, 242, 243, 0)",
      display: "block"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#ff7f1e"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.4s"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#3869c5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.3s"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#4686f4"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.2s"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#3869c5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.3s"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#4686f4"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.2s"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#ff7f1e"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.1s"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#4686f4"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.2s"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#ff7f1e"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.1s"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    fill: "#3869c5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "0s"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.74abbce163c0e42682e9b6dacbcfc0ba.svg";
export { ForwardRef as ReactComponent };